module.exports = __webpack_public_path__ + "static/pray_emoji-6734bddb0be95a6eb3e7d46cd09b5226.svg";